export const enableCookie = ({ commit }) => commit('ENABLE_COOKIE');
